module.exports = __webpack_public_path__ + "img/atari1200_page4.ff006024.jpg";